// Warm welcome lines shown on the login screen. One is picked at random per
// load so each sign-in feels a little different.
export const WELCOME_MESSAGES: string[] = [
  "you showed up. that's already the hardest part.",
  "today doesn't have to be perfect. just present.",
  "small steps still count. so does sitting still.",
  "you've been doing more than you give yourself credit for.",
  "the work will wait. you're worth pacing for.",
  "one card at a time. one thought at a time.",
  "be kind to the version of you that's tired.",
  "this is your quiet space. take a breath before you begin.",
  "you are allowed to make today easier than yesterday.",
  "progress isn't always visible. you're still moving.",
  "things look clearer once they're written down.",
  "let it be messy first. you can shape it later.",
  "the right work today doesn't have to be the most work.",
  "you've solved hard things before. you'll do it again.",
  "soft hands. clear head. one thread at a time.",
  "the day is yours to architect, gently.",
  "tiny wins compound. capture one today.",
  "you don't have to have it all figured out to start.",
  "breathing in. breathing out. ready when you are.",
  "showing up beats being perfect. always.",
  "the unfinished things are not failures. they're in motion.",
  "you carry more than people see. that's okay.",
  "your work matters. so does your rest.",
  "be patient with the slow parts. they have their own value.",
  "one good thought is enough to start a good day.",
];

export function pickWelcome(): string {
  return WELCOME_MESSAGES[Math.floor(Math.random() * WELCOME_MESSAGES.length)];
}
